import React from "react";
import { Button, Card } from "react-bootstrap";
import { IonIcon } from "@ionic/react";
import { cubeOutline, eyeOffOutline, eyeOutline, trashOutline } from "ionicons/icons";
import { getScriptItemKey } from "./scriptEditorUtils";

const getItemKey = (item, index) =>
  item.itemId > 0 ? `item-${item.itemId}` : `temp-${item.tempId ?? index}`;

export default function ScriptItemsCards({
  hiddenItems,
  items,
  onDelete,
  onEdit,
  onToggleVisibility,
  t
}) {
  if (!items.length) {
    return <div className="text-muted py-4 text-center">{t("noItems")}</div>;
  }

  return (
    <div
      className="d-grid gap-3"
      style={{ gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))" }}
    >
      {items.map((item, index) => {
        const visibilityKey = getScriptItemKey(item);
        const isHidden = hiddenItems.has(visibilityKey);
        const edit = () => onEdit(item, index);

        return (
          <Card
            key={getItemKey(item, index)}
            role="button"
            tabIndex={0}
            onClick={edit}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                edit();
              }
            }}
            className={`script-item-card h-100 shadow-sm ${isHidden ? "opacity-50" : ""}`}
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center gap-2">
              <IonIcon icon={cubeOutline} style={{ fontSize: 36 }} />
              <Card.Title className="h6 mb-0 text-break">
                {item.name || `${t("scriptItems")} #${index + 1}`}
              </Card.Title>
              <div className="d-flex gap-2 mt-auto w-100 pt-2">
                <Button
                  size="sm"
                  variant="outline-danger"
                  className="flex-grow-1"
                  onClick={(event) => {
                    event.stopPropagation();
                    onDelete(item);
                  }}
                >
                  <IonIcon icon={trashOutline} className="me-1" />
                  {t("delete")}
                </Button>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  className="flex-grow-1"
                  onClick={(event) => {
                    event.stopPropagation();
                    onToggleVisibility(item);
                  }}
                >
                  <IonIcon
                    icon={isHidden ? eyeOutline : eyeOffOutline}
                    className="me-1"
                  />
                  {isHidden ? t("show") : t("hide")}
                </Button>
              </div>
            </Card.Body>
          </Card>
        );
      })}
    </div>
  );
}
